module.exports = __webpack_public_path__ + "img/heart-slash.ba6ef342.svg";